import { render, staticRenderFns } from "./ItemsTableComponent.vue?vue&type=template&id=218d06ec&scoped=true&"
import script from "./ItemsTableComponent.vue?vue&type=script&lang=js&"
export * from "./ItemsTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./ItemsTableComponent.vue?vue&type=style&index=0&id=218d06ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218d06ec",
  null
  
)

export default component.exports